import defaultImage from './assets/images/theater-talk-thumbnail.jpg';

function TheaterTalksItem(props) {
  const { title, subtitle, image, url, classNames } = props;

  const Tag = url ? 'a' : 'div';
  const tagProps = {};
  if (Tag === 'a') {
    tagProps.href = url;
  }
  const styles = {};
  if (image) {
    styles.backgroundImage = `url(${image})`;
  } else {
    styles.backgroundImage = `url(${defaultImage.src ?? defaultImage})`;
  }

  return (
    <div className="auo-theater-talks__item">
      <Tag
        {...tagProps}
        className={`${classNames} auo-theater-talks__item_content au-dark-overlay`}
        style={styles}
      >
        {title && <h2>{title}</h2>}
        {subtitle && <p>{subtitle}</p>}
      </Tag>
    </div>
  );
}

export default TheaterTalksItem;
